module.exports = __webpack_public_path__ + "static/media/removebg.705b310b.svg";